import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '/node_modules/flag-icons/css/flag-icons.min.css';

function Footer() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <div className="flex flex-col items-center gap-2 text-sm text-gray-600 pt-4 border-t">
      <a
        href="mailto:info@parkinglittleitaly.com"
        className="text-blue-600 hover:text-blue-800 transition-colors duration-200"
      >
        info@parkinglittleitaly.com
      </a>
      <div className="flex items-center gap-2">
        <span className="fi fi-ca"></span>
        <span>Proudly Made in Canada</span>
      </div>
      <Link
        to={isAdminRoute ? '/' : '/admin'}
        className="text-gray-600 hover:text-blue-600 transition-colors duration-200"
      >
        {isAdminRoute ? 'Back to Home' : 'Admin Access'}
      </Link>
    </div>
  );
}

export default Footer;